import React, { memo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { tasksState } from '../../taskRefactored/tasks.slice'
import TaskDetailView from './TaskDetailView'
import styles from '../projectDetail.module.css'

const ProjectTaskDrawer = ({
    activeMainTab,
    drawerRef,
    fullscreenAnimState,
    onFullscreenAnimationEnd,
    isFullscreen,
    width,
    visible,
    onResizeStart,
    taskId,
    onClose,
    projectId,
    filteredAssignees,
    onTaskUpdate,
    onTaskTitleLocalUpdate,
    onTaskClick,
    scrollToSection,
    onScrollToSectionHandled,
    swimLaneOptions,
    onToggleFullscreen,
}) => {
    const { projectTaskList, projectMainTaskList } = useSelector(
        (state) => {
            const tasks = tasksState(state)
            return {
                projectTaskList: tasks.projectTaskList,
                projectMainTaskList: tasks.projectMainTaskList,
            }
        },
        shallowEqual
    )

    if (activeMainTab !== 'support' && activeMainTab !== 'development') {
        return null
    }

    return (
        <div
            ref={drawerRef}
            className={
                fullscreenAnimState === 'entering'
                    ? styles.taskDetailDrawerFullscreenEnter
                    : fullscreenAnimState === 'exiting'
                      ? styles.taskDetailDrawerFullscreenExit
                      : undefined
            }
            onAnimationEnd={
                fullscreenAnimState !== 'idle'
                    ? onFullscreenAnimationEnd
                    : undefined
            }
            style={
                isFullscreen
                    ? {
                          position: 'fixed',
                          inset: 0,
                          zIndex: 9999,
                          backgroundColor: '#f1f5f9',
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '18px',
                      }
                    : {
                          position: 'absolute',
                          top: '0px',
                          right: 0,
                          width: `${width}px`,
                          transform: visible
                              ? 'translateX(0)'
                              : 'translateX(100%)',
                          transition:
                              'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          borderLeft: '1px solid #e2e8f0',
                          backgroundColor: '#fff',
                          boxShadow: 'none',
                          zIndex: 2,
                          height: '100%',
                      }
            }
        >
            {!isFullscreen && (
                <div
                    role="separator"
                    aria-orientation="vertical"
                    aria-label="Resize task panel"
                    className={styles.taskDetailDrawerResizeHandle}
                    onMouseDown={onResizeStart}
                />
            )}
            <TaskDetailView
                taskId={taskId}
                visible={visible}
                onClose={onClose}
                projectId={projectId}
                filteredAssignees={filteredAssignees}
                onTaskUpdate={onTaskUpdate}
                onTaskTitleLocalUpdate={onTaskTitleLocalUpdate}
                onTaskClick={onTaskClick}
                scrollToSection={scrollToSection}
                onScrollToSectionHandled={onScrollToSectionHandled}
                detailSource={
                    activeMainTab === 'development' ? 'main' : 'support'
                }
                swimLaneOptions={swimLaneOptions}
                projectTaskList={
                    activeMainTab === 'development'
                        ? projectMainTaskList
                        : projectTaskList
                }
                isFullscreen={isFullscreen}
                onToggleFullscreen={onToggleFullscreen}
            />
        </div>
    )
}

export default memo(ProjectTaskDrawer)
